export const BERRY_EVENT_ORIGIN = 'https://widget.berryapp.io';
export const BERRY_APP_HOST = 'https://www.berryapp.io';
export const BERRY_APP_WIDGET_PATH = 'js/berry-widget.min.js';
export const BERRY_APP_WIDGET_URL = `${BERRY_APP_HOST}/${BERRY_APP_WIDGET_PATH}`;

export const LOGGER_NAME = 'berry';

export const BERRY_ELEMENT_ID = 'BerryappChatWidget';

export const ADMIN_BOT_NAME = 'nova-external-admins';
export const LEARNER_BOT_NAME = 'nova-external-learners';

export const BERRY_APP_EVENT_HANDLERS_TYPES = {
  BERRY_HANDOFF_EVENT: 'berryHandOffToAgent',
  BERRY_WIDGET_HANDSHAKE: 'berryWidgetHandshake',
  BERRY_WIDGET_STATE_CHANGED: 'berryWidgetStateChange',
};

export const BERRY_API_TOKEN_ENDPOINT = '/berry/get-token';

export const BERRY_ENABLED_TYPES = {
  ADMIN: 'ADMIN',
  LEARNER: 'LEARNER',
  BOTH: 'BOTH',
  NONE: 'NONE',
};
